// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"540":"4d9ff089","541":"0dfd9480","575":"0dfd9480"}[chunkId] + ".chunk.css";
};